import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { userIsSubscribedToAllAlerts } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { dataAlertRemoveMe } from '../actions/menuActions/DataAlertMenuActions';
import { IDataAlertInfo } from '../models/IDataAlertInfo';

export const DataAlertRemoveMeAction: IEntityAction<IDataAlertInfo, {}> = {
  name: EntityActionNames.RemoveSelf,
  translateName: Messages.removeSelfFromAlert_action,
  isVisible: (targetItems: IDataAlertInfo[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: IDataAlertInfo[]) => {
    // only allow clicking is user is subscribed to all alerts
    return userIsSubscribedToAllAlerts(targetItems);
  },
  createReduxAction: (targetItems: IDataAlertInfo[]) => dataAlertRemoveMe(targetItems)
};
